import React, { lazy, Suspense, useEffect, useState } from "react"
import { BrowserRouter as Switch, Route, useLocation } from "react-router-dom"

import { Helmet } from "react-helmet"
import { apiEndpoint } from "./prismic-configuration"
import { client } from "./utils/prismicHelpers"
import "./styles/main.scss"

import { AnimatePresence } from "framer-motion"
import Preloader from "./components/intro/preloader"

//-------------------------------------------------------------------------------
import Loader from "./components/loader"
import Navigation from "./components/nav/navigation"
/*
import BarbaDiv from "./components/barba"

import Home from "./pages/home"
import About from "./pages/about"
import Portfolio from "./pages/portfolio"
import Detail from "./pages/detail"
*/
//const Loader = lazy(() => import("./components/loader"))
//const Navigation = lazy(() => import("./components/nav/navigation"))
const BarbaDiv = lazy(() => import("./components/barba"))

const Home = lazy(() => import("./pages/home"))
const About = lazy(() => import("./pages/about"))
const Portfolio = lazy(() => import("./pages/portfolio"))
const Detail = lazy(() => import("./pages/detail"))
const NotFound = lazy(() => import("./pages/notfound"))



//-------------------------------------------------------------------------------


function App() {
  const renderAppLoader = () => <Loader />
  //console.log("App =>")

  const location = useLocation()
  /*
  */
  const repoNameArray = /([^/]+)\.cdn.prismic\.io\/api/.exec(apiEndpoint)
  const repoName = repoNameArray[1]

  function helmetPrismic(helmetpValue) {

    if (helmetpValue) {
      //console.log("Helmet call")
      return (
        <Helmet>
          <script async defer src={`//static.cdn.prismic.io/prismic.js?repo=${repoName}&new=true`} />
        </Helmet>
      )
    } else {
      return (
        <>
        </>
      )
    }
  }

  const [preloader, setPreloader] = useState(false)

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const listSource = []
        const response = await client.query("").then(res => {

          const outcomes = res.results
          outcomes.map((srcImage) => {

            /*function isAbout() {
              const dataAbout1 = srcImage.data.about_me[0].profile.url
              //console.log("imagen", srcImage.data.about_me[0].profile.url)
              //--
              listSource.push([dataAbout1])
            }

            function isProject() {
              const dataHeader = srcImage.data.hero_banner.url
              const dataFooter = srcImage.data.image_footer.url
              const dataGruop2 = srcImage.data.process_top.url
              const dataGruop1 = srcImage.data.group_content[0].group_image.url
              //--
              listSource.push([dataHeader], [dataFooter], [dataGruop1], [dataGruop2])
            }

            if (srcImage.type === "about") isAbout()
            if (srcImage.type === "project") isProject()
            */
            return true

          })

          const preloader = new Preloader({ info: listSource })

          try {
            const imagesCache = preloader.onComplete()
            return imagesCache ? imagesCache : null
          } catch (error) {
            console.error(error)
          }
        })
        if (response) setPreloader(true)
      } catch (error) {
        console.error(error)
      }
    }
    fetchImages()
  }, [preloader])
  //--
  if (preloader) {
    //console.log("---")
    //<Loader />
    return (
      <>
        {helmetPrismic(false)}
        {/*console.log('App => Loaded')*/}
        <BarbaDiv />
        <Navigation />
        <Suspense fallback={renderAppLoader()}>
          <main className="main__content" aria-labelledby="main-content">
            <AnimatePresence exitBeforeEnter>
              <Switch location={location} key={location.pathname}>
                <Route exact strict path="/" component={Home} />
                <Route exact strict path="/about" component={About} />
                <Route exact strict path="/portfolio" component={Portfolio} />
                <Route exact path="/projects/:uid" component={Detail} />
                <Route path="/error" component={NotFound} />
              </Switch>
            </AnimatePresence>
          </main>
        </Suspense>
      </>
    )
  } else {
    return (
      <Loader />
    )
  }
}

export default App
